import { render, staticRenderFns } from "./CaQuiz.vue?vue&type=template&id=0ae1e8eb&"
import script from "./CaQuiz.vue?vue&type=script&lang=js&"
export * from "./CaQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports